module.exports = __webpack_public_path__ + "img/vipjf388.2ad9b166.png";